// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-_vuG","toggle":"styles_toggle__2G_lY","preview":"styles_preview__2syxZ"};